import React from 'react'

import { SpookySkeleton, SkeletonButton, SkeletonIcon, SkeletonText } from '@offerzen/pinata-shame'

import styles from './styles'

const SkeletonWorkHistoryScene = () => (
  <SpookySkeleton>
    <For of={[0, 1]} index="index">
      <div key={index} className={styles.workHistory}>
        <div className={styles.text}>
          <SkeletonText theme="dark" width={200} />
          <SkeletonText theme="dark" width={240} />
        </div>

        <div className={styles.actions}>
          <SkeletonIcon theme="dark" />
          <SkeletonIcon theme="dark" />
        </div>
      </div>
    </For>

    <SkeletonButton className={styles.button} theme="dark" />

    <div className={styles.footer}>
      <SkeletonButton theme="dark" />
    </div>
  </SpookySkeleton>
)

export default SkeletonWorkHistoryScene
